import { Tabs } from "antd"
import React from "react"
import { useLocation, useNavigate } from "react-router-dom"

import { useAppSelector } from "../../../../hooks/use-app-selector.ts"
import { useTabsOpenInNewTab } from "../../../../hooks/use-tabs-open-in-new-tab.tsx"
import {
  selectActiveBranch,
  selectActiveBranchId,
  selectCompanyIsMultiBranch
} from "../../../Branches/redux/branches.slice.ts"
import { useCompanyDefaultsSubtabs } from "./company-defaults-access.ts"

export function CompanyDefaultsSubTabs() {
  const navigate = useNavigate()
  const pathname = useLocation()?.pathname
  const subtabs = useCompanyDefaultsSubtabs()
  const isMultiBranch = useAppSelector(selectCompanyIsMultiBranch)
  const activeBranchId = useAppSelector(selectActiveBranchId)
  const activeBranchName = useAppSelector(selectActiveBranch)?.name
  // The tab stays named "Company Defaults" everywhere — only the scope line
  // underneath changes — so a branch workspace never reads as a second,
  // HQ-only settings surface the way the "Branch & System" rename does for
  // Company & System.
  const isBranchScope = isMultiBranch && !!activeBranchId

  const activeKey = subtabs
    .filter(({ key }) => pathname === key || pathname?.startsWith(`${key}/`))
    .reduce(
      (longest, item) =>
        item.key.length > longest.length ? item.key : longest,
      ""
    )

  const newTab = useTabsOpenInNewTab((key) =>
    subtabs.some((tab) => tab.key === key) ? key : undefined
  )

  return (
    <div className="mb-3" {...newTab.handlers}>
      {newTab.contextMenu}
      <div className="text-xs uppercase tracking-wide text-gray-400 mb-1">
        {isBranchScope
          ? `Company Defaults · Defaults for ${activeBranchName ?? "this branch"}`
          : "Company Defaults"}
      </div>
      <Tabs
        activeKey={activeKey || subtabs[0]?.key}
        items={subtabs}
        onChange={navigate}
        className="[&_.ant-tabs-nav]:mb-0 [&_.ant-tabs-tab]:py-1"
      />
    </div>
  )
}
